import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvLabelledField from '../atoms/OvLabelledField';
import OvOrderEditButton from '../atoms/OvOrderEditButton';
import OvRecordDetailsSection from '../molecules/OvRecordDetailsSection';
import OvEditVideoDetailsDialog from '../molecules/OvEditVideoDetailsDialog';
import { AdminVideo } from '../../../common/model/dto/video/admin-video';
import Colours from '../../../design-system/colours';
import Variables from '../../../design-system/variables';

interface OvVideoDetailsSectionProps {
  video: AdminVideo;
  isEditable: boolean;
  onSaved: () => void;
}

const OvVideoDetailsSection: FC<OvVideoDetailsSectionProps> = ({
  video,
  isEditable,
  onSaved,
}) => {
  const { t } = useTranslation();
  const [isEditing, setIsEditing] = useState(false);

  return (
    <OvRecordDetailsSection
      title={t('videos.details.detailsSection')}
      action={
        isEditable && (
          <OvOrderEditButton
            label={t('videos.details.editDetails')}
            onClick={() => setIsEditing(true)}
          />
        )
      }
    >
      <Fields>
        <OvLabelledField label={t('videos.fields.title')}>
          {video.title}
        </OvLabelledField>
        <OvLabelledField label={t('videos.fields.description')}>
          {video.description ?? (
            <Missing>{t('videos.details.noDescription')}</Missing>
          )}
        </OvLabelledField>
      </Fields>
      {isEditable && (
        <OvEditVideoDetailsDialog
          video={video}
          isOpen={isEditing}
          onClose={() => setIsEditing(false)}
          onSaved={onSaved}
        />
      )}
    </OvRecordDetailsSection>
  );
};

export default OvVideoDetailsSection;

const Fields = styled.dl`
  display: flex;
  flex-direction: column;
  gap: ${Variables.spacing.SMALL};
  margin: 0;
  white-space: pre-wrap;
`;

const Missing = styled.span`
  color: ${Colours.OV_CHARCOAL};
`;
